import { AnimatePresence, motion } from 'motion/react';
import React from 'react';

import { usePanelTransitionDuration } from '@gitbook/spine-react';

import { useNavigationState } from '../../../navigation';

const COLLAPSED_SIDESHEET_TYPES = ['comments', 'agent'];

export function ChangeRequestSidePanelCollapsible(props: {
    children: React.ReactNode;
    width: number;
    className?: string;
    direction: 'left' | 'right';
}) {
    const { children, width, className, direction } = props;
    const duration = usePanelTransitionDuration();
    const isCollapsed = useChangeRequestSidePanelCollapsed();

    return (
        <AnimatePresence initial={false}>
            {!isCollapsed ? (
                <motion.div
                    className={className}
                    style={{ width }}
                    transition={{
                        duration: duration / 1000,
                        ease: [0.4, 0, 0.2, 1],
                    }}
                    variants={{
                        exit: { [direction === 'left' ? 'marginLeft' : 'marginRight']: -width },
                        animate: {
                            [direction === 'left' ? 'marginLeft' : 'marginRight']: 0,
                        },
                    }}
                    initial="exit"
                    animate="animate"
                    exit="exit"
                >
                    {children}
                </motion.div>
            ) : null}
        </AnimatePresence>
    );
}

export function useChangeRequestSidePanelCollapsed() {
    const { screen, overlay } = useNavigationState();

    return React.useMemo(() => {
        if (screen.type === 'space') {
            return COLLAPSED_SIDESHEET_TYPES.includes(screen.sideSheet?.type ?? '');
        }

        return (
            overlay &&
            'sideSheet' in overlay &&
            COLLAPSED_SIDESHEET_TYPES.includes(overlay.sideSheet?.type ?? '')
        );
    }, [screen, overlay]);
}
